// language=GraphQL
export const ALL_TRAVEL_SELECTION_BLOCKS_QUERY = `query Query($withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false, $withTravelsPricingCurrencyOverride: Boolean = false, $withTravelsFaqs: Boolean = false) {
  travelSelectionBlocks: cmsTravelSelectionBlocks {
    id
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withTravelsAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withTravelsTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTravelsTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withTravelsLabel) {
        id
        label
      }
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withTravelsSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withTravelsSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withTravelsTenantSettings) {
        id
        tenant @include(if: $withTravelsTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withTravelsHighlights) {
        id
        text
      }
      partners @include(if: $withTravelsPartners) {
        id
        name
        url
        logo @include(if: $withTravelsPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withTravelsPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withTravelsTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelsTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withTravelsTeams) {
        id
        name
        members @include(if: $withTravelsTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {
        id
        accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
        displayDetails
      }
      accommodations @include(if: $withTravelsAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withTravelsAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withTravelsDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withTravelsTestimonials) {
        id
        contentBlock @include(if: $withTravelsTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withTravelsMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withTravelsMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withTravelsGallery) {
        id
        images @include(if: $withTravelsGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withTravelsTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withTravelsTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelsTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withTravelsTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withTravelsItinerary) {
        id
        items @include(if: $withTravelsItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withTravelsPricing) {
        id
        ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withTravelsPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
          suppressBusBoardingSelection
        }
        webhookConfig @include(if: $withTravelsPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withTravelsPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withTravelsPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withTravelsPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withTravelsPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withTravelsPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
        currencyOverride @include(if: $withTravelsPricingCurrencyOverride) {
          id
          enabled
          exchangeRate
        }
      }
      minPrice
      minPriceManualOverride
      currency
      faqs @include(if: $withTravelsFaqs) {
        id
        question
        answer
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_TRAVEL_SELECTION_BLOCK_QUERY = `query Query($id: ID!, $withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false, $withTravelsPricingCurrencyOverride: Boolean = false, $withTravelsFaqs: Boolean = false) {
  travelSelectionBlock: cmsTravelSelectionBlock(id: $id) {
    id
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withTravelsAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withTravelsTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTravelsTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withTravelsLabel) {
        id
        label
      }
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withTravelsSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withTravelsSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withTravelsTenantSettings) {
        id
        tenant @include(if: $withTravelsTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withTravelsHighlights) {
        id
        text
      }
      partners @include(if: $withTravelsPartners) {
        id
        name
        url
        logo @include(if: $withTravelsPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withTravelsPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withTravelsTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelsTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withTravelsTeams) {
        id
        name
        members @include(if: $withTravelsTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {
        id
        accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
        displayDetails
      }
      accommodations @include(if: $withTravelsAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withTravelsAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withTravelsDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withTravelsTestimonials) {
        id
        contentBlock @include(if: $withTravelsTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withTravelsMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withTravelsMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withTravelsGallery) {
        id
        images @include(if: $withTravelsGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withTravelsTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withTravelsTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelsTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withTravelsTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withTravelsItinerary) {
        id
        items @include(if: $withTravelsItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withTravelsPricing) {
        id
        ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withTravelsPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
          suppressBusBoardingSelection
        }
        webhookConfig @include(if: $withTravelsPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withTravelsPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withTravelsPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withTravelsPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withTravelsPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withTravelsPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
        currencyOverride @include(if: $withTravelsPricingCurrencyOverride) {
          id
          enabled
          exchangeRate
        }
      }
      minPrice
      minPriceManualOverride
      currency
      faqs @include(if: $withTravelsFaqs) {
        id
        question
        answer
      }
    }
  }
}`

// language=GraphQL
export const CREATE_TRAVEL_SELECTION_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsTravelSelectionBlockInput, $withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false, $withTravelsPricingCurrencyOverride: Boolean = false, $withTravelsFaqs: Boolean = false) {
    travelSelectionBlock: createCmsTravelSelectionBlock(input: $input) {
      id
      travels @include(if: $withTravels) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withTravelsAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withTravelsTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTravelsTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withTravelsLabel) {
          id
          label
        }
        title
        description
        introVideoUrl
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withTravelsSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withTravelsSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withTravelsTenantSettings) {
          id
          tenant @include(if: $withTravelsTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withTravelsHighlights) {
          id
          text
        }
        partners @include(if: $withTravelsPartners) {
          id
          name
          url
          logo @include(if: $withTravelsPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withTravelsPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withTravelsTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withTravelsTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withTravelsTeams) {
          id
          name
          members @include(if: $withTravelsTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {
          id
          accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
          displayDetails
        }
        accommodations @include(if: $withTravelsAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withTravelsAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withTravelsDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withTravelsTestimonials) {
          id
          contentBlock @include(if: $withTravelsTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withTravelsMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withTravelsMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withTravelsGallery) {
          id
          images @include(if: $withTravelsGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withTravelsTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withTravelsTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withTravelsTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withTravelsTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withTravelsItinerary) {
          id
          items @include(if: $withTravelsItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withTravelsPricing) {
          id
          ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withTravelsPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
            suppressBusBoardingSelection
          }
          webhookConfig @include(if: $withTravelsPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withTravelsPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withTravelsPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withTravelsPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withTravelsPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withTravelsPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
          currencyOverride @include(if: $withTravelsPricingCurrencyOverride) {
            id
            enabled
            exchangeRate
          }
        }
        minPrice
        minPriceManualOverride
        currency
        faqs @include(if: $withTravelsFaqs) {
          id
          question
          answer
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_SELECTION_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsTravelSelectionBlockInput, $withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false, $withTravelsPricingCurrencyOverride: Boolean = false, $withTravelsFaqs: Boolean = false) {
    travelSelectionBlock: updateCmsTravelSelectionBlock(input: $input) {
      id
      travels @include(if: $withTravels) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withTravelsAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withTravelsTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTravelsTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withTravelsLabel) {
          id
          label
        }
        title
        description
        introVideoUrl
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withTravelsSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withTravelsSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withTravelsTenantSettings) {
          id
          tenant @include(if: $withTravelsTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withTravelsHighlights) {
          id
          text
        }
        partners @include(if: $withTravelsPartners) {
          id
          name
          url
          logo @include(if: $withTravelsPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withTravelsPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withTravelsTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withTravelsTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withTravelsTeams) {
          id
          name
          members @include(if: $withTravelsTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {
          id
          accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
          displayDetails
        }
        accommodations @include(if: $withTravelsAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withTravelsAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withTravelsDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withTravelsTestimonials) {
          id
          contentBlock @include(if: $withTravelsTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withTravelsMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withTravelsMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withTravelsGallery) {
          id
          images @include(if: $withTravelsGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withTravelsTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withTravelsTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withTravelsTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withTravelsTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withTravelsItinerary) {
          id
          items @include(if: $withTravelsItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withTravelsPricing) {
          id
          ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withTravelsPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
            suppressBusBoardingSelection
          }
          webhookConfig @include(if: $withTravelsPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withTravelsPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withTravelsPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withTravelsPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withTravelsPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withTravelsPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
          currencyOverride @include(if: $withTravelsPricingCurrencyOverride) {
            id
            enabled
            exchangeRate
          }
        }
        minPrice
        minPriceManualOverride
        currency
        faqs @include(if: $withTravelsFaqs) {
          id
          question
          answer
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_SELECTION_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTravelSelectionBlockInput) {
    deleteCmsTravelSelectionBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVEL_SELECTION_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTravelSelectionBlockInput) {
    forceDeleteCmsTravelSelectionBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION = `
  mutation Mutation($input: addCmsTravelSelectionBlockTravelsInput) {
    addCmsTravelSelectionBlockTravels(input: $input) {
      id
      travelIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION = `
  mutation Mutation($input: removeCmsTravelSelectionBlockTravelsInput) {
    removeCmsTravelSelectionBlockTravels(input: $input) {
      id
      travelIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION = `
  mutation Mutation($input: createCmsTravelSelectionBlockTravelsInput) {
    createCmsTravelSelectionBlockTravels(input: $input) {
      id
      travelIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION = `
  mutation Mutation($input: deleteCmsTravelSelectionBlockTravelsInput) {
    deleteCmsTravelSelectionBlockTravels(input: $input) {
      id
      travelIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_SELECTION_BLOCK_TRAVELS_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsTravelSelectionBlockTravelsOrderInput) {
    updateCmsTravelSelectionBlockTravelsOrder(input: $input) {
      id
      travelIds
    }
  }`
